import amplifyOutputs from "../amplify_outputs.json";

export async function sendEmail(formData) {
  try {
    const functionUrl = amplifyOutputs.custom.contactEmailUrl;

    console.log("📤 Sending email with data:", {
      email: formData?.email,
      message: formData?.description,
      priority: formData?.priority,
      subject: formData?.subject,
    });

    const response = await fetch(functionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: formData?.email,
        message: formData?.description,
        priority: formData?.priority,
        subject: formData?.subject,
      }),
    });

    console.log("📥 Lambda response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Lambda responded with:", errorText);
      throw new Error("Failed to send email");
    }

    const result = await response.json();
    console.log("✅ Lambda responded with JSON:", result);
    return result;
  } catch (e) {
    console.error("❌ Email sending failed:", e);
    throw new Error(e?.message || "Failed to send email");
  }
}